import React, { useState } from 'react'
import { useHistory, useParams, useLocation } from "react-router-dom";

import Header from '../../components/header/index.js'
import Footer from '../../components/footer/index.js'

import IntegrationLayerHome from '../../components/integrationLayerHome/index.js'


const IntegrationLayer = () => {

    return (
        <div>
            <Header />

            <IntegrationLayerHome />

            <Footer />
        </div>
    );
}

export default IntegrationLayer;
